module.exports = __webpack_public_path__ + "static/media/mobile_hero_contact.2ef2110e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/mobile_hero_contact.png
// module id = 90
// module chunks = 19